document.addEventListener("DOMContentLoaded", function () {
  const cartBtns = document.querySelectorAll(".quick-cart-btn");
  cartBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      btn.setAttribute("src", "#");
    });
  });
});
